export const PARCEIROS_PUBLIC_NAV = [
  { href: '#por-que', label: 'Por que indicar' },
  { href: '#ganhos', label: 'Quanto pode ganhar' },
  { href: '#como-funciona', label: 'Como funciona' },
  { href: '#portal', label: 'Portal' },
  { href: '#duvidas', label: 'Dúvidas' },
] as const

export const PARCEIROS_HERO_PONTOS = [
  'Cadastro gratuito',
  'Você não precisa conduzir a negociação',
  'Indicações e comissões acompanhadas pelo portal',
] as const

export const PARCEIROS_POR_QUE = [
  {
    titulo: 'O que a Rocket oferece',
    detalhe: 'Busca e descoberta de produtos para o e-commerce. A loja ajuda o cliente a encontrar o que já está no catálogo.',
  },
  {
    titulo: 'Quem é o cliente ideal',
    detalhe: 'Lojistas que querem vender mais no próprio site e aceitam uma conversa comercial da Rocket Search.',
  },
  {
    titulo: 'O que a loja ganha',
    detalhe: 'Uma proposta conduzida pelo time da Rocket. Você apresenta o contato. A venda não fica na sua mão.',
  },
] as const

export const PARCEIROS_GANHOS = [
  {
    titulo: 'Agência e plataforma',
    detalhe:
      'Comissão recorrente enquanto o cliente indicado permanecer ativo. O percentual é o que for confirmado na aprovação do portal.',
  },
  {
    titulo: 'Indicador',
    detalhe:
      'Comissão quando um cliente novo fecha e o pagamento é confirmado, além das promoções do programa. O formato também é confirmado na aprovação.',
  },
] as const

export const PARCEIROS_BENEFICIOS = [
  { titulo: 'A Rocket negocia', detalhe: 'Contato, reunião e proposta ficam com o time da Rocket Search.' },
  { titulo: 'Você acompanha', detalhe: 'Cada etapa da indicação aparece no portal, do recebimento ao fechamento.' },
  { titulo: 'A comissão fica visível', detalhe: 'Quando o cliente novo paga, o status da comissão entra na mesma tela.' },
] as const

export const PARCEIROS_STEPS = [
  { step: '1', title: 'Cadastre-se grátis', detail: 'Envie seus dados e aceite as regras. A equipe valida e libera o portal.' },
  { step: '2', title: 'Indique a loja', detail: 'Passe nome, empresa e contato de um lojista que ainda não está na carteira.' },
  { step: '3', title: 'A Rocket conduz a venda', detail: 'O time assume o contato, a reunião e a proposta.' },
  { step: '4', title: 'Você acompanha o resultado', detail: 'O portal mostra o andamento e a comissão quando o pagamento do cliente novo é confirmado.' },
] as const

export const PARCEIROS_AUDIENCIA = [
  {
    titulo: 'Agências',
    detalhe: 'Indicam as lojas que já atendem e acompanham o fechamento sem precisar vender a Rocket no lugar do time.',
  },
  {
    titulo: 'Plataformas',
    detalhe: 'Indicam a própria base de lojistas e veem, no portal, quais conversas avançaram.',
  },
  {
    titulo: 'Indicadores',
    detalhe: 'Ganham quando a loja indicada fecha e o pagamento é confirmado, e podem entrar nas promoções do programa.',
  },
  {
    titulo: 'Profissionais',
    detalhe: 'Podem participar. No cadastro, o campo pede o nome da empresa ou do negócio pelo qual você indica.',
  },
] as const

export const PARCEIROS_FAQ = [
  {
    pergunta: 'Quanto posso ganhar?',
    resposta:
      'Depende do perfil aprovado. Agência e plataforma têm comissão recorrente enquanto o cliente indicado estiver ativo. Indicador recebe quando um cliente novo fecha e o pagamento é confirmado, e pode participar das promoções. O percentual de cada perfil é confirmado na aprovação do portal. O que não estiver nessa confirmação não é devido.',
  },
  {
    pergunta: 'O que é uma indicação válida?',
    resposta:
      'Uma loja que ainda não está na carteira da Rocket Search. Envie nome, empresa e contato quando a pessoa pediu a indicação ou é um contato profissional que pode receber uma abordagem. Indicação duplicada, cliente antigo ou negócio que não fecha não gera comissão.',
  },
  {
    pergunta: 'Quem entra em contato com a loja?',
    resposta: 'O time da Rocket Search. Você não conduz a reunião nem a proposta.',
  },
  {
    pergunta: 'Quando a comissão é gerada?',
    resposta: 'Quando a Rocket Search fecha um cliente novo e o pagamento desse cliente é confirmado.',
  },
  {
    pergunta: 'Como acompanho a negociação?',
    resposta:
      'Pelo portal. Os status são recebido, em contato, reunião, proposta, fechado, comissão pendente, comissão liberada e pago.',
  },
  {
    pergunta: 'Quando e como recebo?',
    resposta:
      'A comissão aparece no portal quando é liberada. O pagamento segue as condições do programa, depois da confirmação do pagamento do cliente. O texto completo está em Regras completas.',
  },
] as const
